// Module
var code = `<div class="recent-transactions"> <component-heading></component-heading> <div id="transaction-list"></div> </div>`;
// Exports
export default code;